(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["open_chat_bot"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var launcher = document.querySelector('.chat__launcher');
  if (launcher) {
    launcher.addEventListener('click', function(e) {
      e.preventDefault();
      if (typeof zE !== 'undefined') {
        zE('messenger', 'open');
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
